import { matchRoutes, useLocation } from 'react-router-dom';

export const useCurrentPath = (routes: { path: string; label: string }[]) => {
  const location = useLocation();

  return routes.find(element => matchRoutes([element], location));
};
